export default [
  {
    path: '/hr/employees',
    name: 'Employees',
    component: () => import('@/views/Hr/Employees/Index.vue'),
    meta: {
      pageTitle: 'Personel Kartları',
      breadcrumb: [
        {
          text: 'Personel Kartları',
          active: true,
        },
      ],
      resource: 'APP_EMPLOYESS',
      action: 'read',
    },
  },
  {
    path: '/hr/employees/add',
    name: 'EmployeesAdd',
    component: () => import('@/views/Hr/Employees/Add.vue'),
    meta: {
      pageTitle: 'Personel Kartı Ekle',
      breadcrumb: [
        {
          text: 'Personel Kartları',
          to: '/hr/employees',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_EMPLOYESS',
      action: 'read',
    },
  },
  {
    path: '/hr/employees/edit/:id',
    name: 'EmployeesEdit',
    component: () => import('@/views/Hr/Employees/Edit.vue'),
    meta: {
      pageTitle: 'Personel Kartı Güncelle',
      breadcrumb: [
        {
          text: 'Personel Kartları',
          to: '/hr/employees',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_EMPLOYESS',
      action: 'read',
    },
  },
  {
    path: '/hr/employees/view/:id',
    name: 'EmployeesView',
    component: () => import('@/views/Hr/Employees/View.vue'),
    meta: {
      pageTitle: 'Personel Kartı Görüntüle',
      breadcrumb: [
        {
          text: 'Personel Kartları',
          to: '/hr/employees',
          active: false,
        },
        {
          text: 'Görüntüle',
          active: true,
        },
      ],
      resource: 'APP_EMPLOYESS',
      action: 'read',
    },
  },
]
